/**
 * depenses.js
 * -----------
 * Demandes de depense et circuit de validation.
 *
 * Extrait de `directeurApi.js` (559 lignes, toutes les fonctions ajoutees a la
 * suite). Chaque lot ajoutait ses appels en fin de fichier : deux lots ouverts
 * en meme temps entraient donc systematiquement en conflit sur ce fichier.
 * `directeurApi.js` reste le point d'entree — il re-exporte ces modules — pour
 * qu'aucun ecran n'ait a changer ses imports.
 */
import axiosClient from "../axiosClient";

/* ── Demandes de dépense et circuit de validation ── */

/** GET /directeur/depenses/ -> { demandes, lignes, stats, circuit, annee } */
export async function getDirecteurDepenses() {
  const { data } = await axiosClient.get("/directeur/depenses/");
  return data || {};
}

/** POST /directeur/depenses/ — crée la demande et son circuit de validation. */
export async function creerDemandeDepense(payload) {
  const { data } = await axiosClient.post("/directeur/depenses/", payload);
  return data;
}

/**
 * POST /directeur/depenses/<id>/decision/ — tranche l'étape courante.
 * @param {"approve"|"reject"} decision
 */
export async function deciderDemandeDepense(id, decision, commentaire = "") {
  const { data } = await axiosClient.post(`/directeur/depenses/${id}/decision/`, {
    decision,
    commentaire,
  });
  return data;
}
